import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetWeightCertificatesFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  config: Partial<HttpClientConfig>
}

export function getWeightCertificatesFactory({
  repository,
}: GetWeightCertificatesFactoryDependencies) {
  return async function getWeightCertificates({ shipmentUUID, config }: Params) {
    try {
      return await repository.getWeightCertificates(shipmentUUID, config)
    } catch (error) {
      throw new Error('Could not get weight certificates', { cause: error as Error })
    }
  }
}

export function getWeightCertificates({ shipmentUUID, config }: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newGetWeightCertificates = getWeightCertificatesFactory({
    repository,
  })
  return newGetWeightCertificates({ shipmentUUID, config })
}
